import { useCallback, useEffect, useState } from 'react';
import { Platform } from 'react-native';
import useDynamicFontSize from './useDynamicFontSize';

const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
    };
};

export const useOverflowStyle = (targetRef, styleGuide) => {
    const [overflowStyle, setOverflowStyle] = useState();
    // const { calculateFontSize } = useDynamicFontSize();

    const handleResize = useCallback(
        () =>
            debounce(() => {
                if (Platform.OS !== 'web' || !targetRef.current) {
                    return false;
                }

                const style = {};

                if (targetRef.current.clientWidth < targetRef.current.scrollWidth) {
                    if (styleGuide.condensedFontFamily) {
                        style.fontFamily = styleGuide.condensedFontFamily;
                        //style.fontSize   = calculateFontSize(styleGuide.fontSize);
                    }
                }

                setOverflowStyle(style);
            }, 200),
        [styleGuide, targetRef]
    );

    useEffect(() => {
        if (Platform.OS.equals('web')) {
            window.addEventListener('resize', handleResize);
        }

        return () => {
            if (Platform.OS.equals('web')) {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, [styleGuide, targetRef]); // eslint-disable-line react-hooks/exhaustive-deps

    return overflowStyle;
};
